module.exports = __webpack_public_path__ + "static/media/wuyouzu.73b3f03a.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/wuyouzu.png
// module id = 751
// module chunks = 0